import { render, staticRenderFns } from "./MyChoiceKeyboarding.vue?vue&type=template&id=e57af1c0&scoped=true&"
import script from "./MyChoiceKeyboarding.vue?vue&type=script&lang=js&"
export * from "./MyChoiceKeyboarding.vue?vue&type=script&lang=js&"
import style0 from "./MyChoiceKeyboarding.vue?vue&type=style&index=0&id=e57af1c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57af1c0",
  null
  
)

export default component.exports